/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { dateUtils } from 'utils';
import { useOrganization, useVideoContext } from 'hooks';
import VideoSessionTwilio from './VideoSessionTwilio';
import VideoSessionWhereby from './VideoSessionWhereby';

function VideoSession({ expiresAt, participants, videoSessionId, appointmentId, accountId, twilioSessionToken, data }) {
  const { organizationId, wherebyUrl } = data;
  const { data: organization } = useOrganization(organizationId);
  const { wherebyIntegration } = organization.features || {};
  const [sessionType, setSessionType] = useState(null);
  const { disconnect } = useVideoContext();
  const isPastVideoSession = useMemo(() => (expiresAt ? dateUtils.isDateBeforeNow(expiresAt) : false), [expiresAt]);
  useEffect(() => {
    if (isPastVideoSession) disconnect();
    if (wherebyIntegration && wherebyUrl) {
      setSessionType('whereby');
    } else {
      setSessionType('twilio');
    }
  }, [isPastVideoSession, wherebyIntegration, wherebyUrl]);

  return (
    <>
      {sessionType === 'twilio' && (
        <VideoSessionTwilio
          participants={participants}
          videoSessionId={videoSessionId}
          appointmentId={appointmentId}
          accountId={accountId}
          twilioSessionToken={twilioSessionToken}
          data={data}
        />
      )}
      {sessionType === 'whereby' && (
        <VideoSessionWhereby participants={participants} videoSessionId={videoSessionId} appointmentId={appointmentId} accountId={accountId} data={data} />
      )}
    </>
  );
}

VideoSession.propTypes = {
  expiresAt: PropTypes.string,
  participants: PropTypes.arrayOf(PropTypes.any).isRequired,
  appointmentId: PropTypes.string,
  videoSessionId: PropTypes.string,
  accountId: PropTypes.string,
  twilioSessionToken: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

VideoSession.defaultProps = {
  expiresAt: '',
  appointmentId: '',
  videoSessionId: '',
  twilioSessionToken: '',
  accountId: '',
};

export default VideoSession;
